/* eslint-disable react/no-array-index-key */
import * as React from 'react';

import { Col, Row } from 'antd';
import { Space } from 'farmhub-ui-core';

import { theme } from 'styled';

import EntityCardItem from '../EntityCardItem';

interface ListAccountProps {
  entities: any[];
  handleClickEntity: (e: string) => void;
}

const ListAccountMobile = ({
  entities,
  handleClickEntity,
}: ListAccountProps): JSX.Element => (
  <>
    <Row gutter={[18, 18]} style={{ padding: theme.app.padding.horizontal }}>
      {entities.map((item: any, index: number) => (
        <Col key={index} span={12}>
          <EntityCardItem
            item={item}
            onClick={() => !item?.disabled && handleClickEntity(item.type)}
          />
        </Col>
      ))}
    </Row>
    <Space height={36} />
  </>
);

export default ListAccountMobile;
